export const ACTIVE_STAFF = 'ACTIVE';
export const INACTIVE_STAFF = 'DELETED';
export type EmployeeType = 'CLERK' | 'MANAGER';
export type StaffTabs = typeof ACTIVE_STAFF | typeof INACTIVE_STAFF;

export interface Staff {
    currentTab: StaffTabs;
}

export interface CreateStaff {
    fullName: string;
    email: string;
    employeeType?: string;
}
export interface CreateStaffFormProps {
    loading?: boolean;
    onSubmit: (formData: CreateStaff) => void;
    submitButtonText?: string;
}
